import { type GetSeoTagsResponse } from './tags'

export const getSeoTagsMock: GetSeoTagsResponse = [
  {
    title: 'iPhone 12 PRO MAX Vs iPhone 8 Plus Size',
    slug: '/en-us/compare/iphone-11-pro-max/iphone-8-plus',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/iphone-11-pro-max/iphone-8-plus',
    },
  },
  {
    title: 'Samsung Galaxy S6 Vs S7',
    slug: '/en-us/compare/galaxy-s6/galaxy-s7',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/galaxy-s6/galaxy-s7',
    },
  },
  {
    title: '11 PRO MAX Vs 11',
    slug: '/en-us/compare/iphone-11-pro/iphone-11-pro-max',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/iphone-11-pro/iphone-11-pro-max',
    },
  },
  {
    title: 'S21',
    slug: '/en-us/l/galaxy-s21/67cd8f6f-97a6-4808-adb9-34d0329516dc',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/l/galaxy-s21/67cd8f6f-97a6-4808-adb9-34d0329516dc',
    },
  },
  {
    title: 'iPhone 13 PRO',
    slug: '/en-us/l/iphone-13-pro/01adbd73-12e5-4950-a33e-51a8d6c3d935',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/l/iphone-13-pro/01adbd73-12e5-4950-a33e-51a8d6c3d935',
    },
  },
  {
    title: 'iPhone 12 Vs Samsung Galaxy S21',
    slug: '/en-us/compare/galaxy-s21/iphone-12',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/galaxy-s21/iphone-12',
    },
  },
  {
    title: 'iPhone 11 PRO MAX Versus iPhone 12 PRO MAX',
    slug: '/en-us/compare/iphone-11-pro-max/iphone-12-pro-max',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/iphone-11-pro-max/iphone-12-pro-max',
    },
  },
  {
    title: 'Xiaomi Mi 11 Ultra Vs Samsung S21 Ultra',
    slug: '/en-us/compare/galaxy-s21/xiaomi-mi-11',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/galaxy-s21/xiaomi-mi-11',
    },
  },
  {
    title: 'Difference Between iPhone 11 PRO MAX And 13 PRO MAX',
    slug: '/en-us/compare/iphone-11-pro-max/iphone-13-pro-max',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/compare/iphone-11-pro-max/iphone-13-pro-max',
    },
  },
  {
    title: 'iPhone 8',
    slug: '/en-us/l/apple-iphone-8/8955f1e4-780c-4861-8e5c-5bbc4d1efb0d',
    link: {
      type: 'external',
      href: 'https://www.backmarket.com/en-us/l/apple-iphone-8/8955f1e4-780c-4861-8e5c-5bbc4d1efb0d',
    },
  },
]
